// extracted by mini-css-extract-plugin
export default {"distributorUsageTable":"TenantsUsageEntries_distributorUsageTable__vbv5H"};